import * as Business from '../business';
import * as Contacts from '../contacts/actions';
import * as errors   from '../util/errors';
import * as Forms    from '../components/forms';
import * as User     from '../user';
import { compose }   from 'redux';
import { connect }   from 'react-redux';
import classnames    from 'classnames';
import ms            from 'ms';
import React         from 'react';


export default connect(
  (state, { businessID }) => ({
    businessID,
    businessName:         Business.getBusinessName(state, businessID),
    providers:            Business.getProviders(state, businessID),
    provider:             Business.getCurrentProvider(state, businessID),
    isManager:            User.isManager(state, businessID),
    defaultThankYouDelay: Business.getThankYouDelay(state, businessID)
  }),
  dispatch => ({
    createContact: compose(dispatch, Contacts.createContact)
  })
)(AddOneForm);


export function AddOneForm({
  businessID,
  businessName,
  defaultThankYouDelay,
  provider,
  providers,
  createContact,
  isManager,
  navigateTo
}) {
  // Get business' default delay for thank you

  const initial = {
    provider:     provider ? provider.id : '',
    sendThankYou: 'yes',
    sendDelay:    0
  };

  function onSaveError(error) {
    errors.showDialogError(error);
  }

  async function save(customer) {
    const hasProvider       = !!customer.provider;
    const assistingProvider = hasProvider ? customer.provider : null;

    // customer.provider is the assisting team member
    const response = await createContact({
      businessID,
      customer: {
        ...customer,
        provider:     assistingProvider,
        source:       { name: 'member' },
        sendThankYou: customer.sendThankYou === 'yes',
        sendDelay:    customer.sendDelay
      },
      defaultThankYouDelay,
      // current provider that added the customer
      provider
    });

    // Redirect to conversation if available
    const customerID     = response.id;
    const conversationID = response.conversation?.id;
    const redirectURL    = conversationID ?
      `/${businessID}/inbox/${conversationID}` :
      `/${businessID}/contacts/${customerID}`;
    navigateTo(redirectURL);
  }

  return (
    <Forms.Form record={initial} save={save} validate={validate} onSaveError={onSaveError}>
      {providers && defaultThankYouDelay && (
        <AddOneCustomerFields businessName={businessName} providers={providers} isManager={isManager} defaultThankYouDelay={defaultThankYouDelay}/>
      )}
    </Forms.Form>
  );
}


function validate(fields) {
  if (!fields['contact.email.address'] && !fields['contact.phone.number'])
    throw Error('Please provide an email address and/or phone number');
}


function AddOneCustomerFields({ businessName, providers, isManager, defaultThankYouDelay, ...form }) {
  return (
    <div className="add-customer-form list block">
      <ul>
        <Forms.Error {...form}/>
        <Forms.Input
          {...form}
          name="name.full"
          type="text"
          label="Name"
          required={true}
          autoFocus={true}
          assistType="capitalize"
          autoComplete="off"/>
        <Forms.Input
          {...form}
          name="contact.email.address"
          placeholder="name@email.com"
          type="email"
          label="Email"
          required={false}
          autoComplete="off"/>
        <Forms.Input
          {...form}
          name="contact.phone.number"
          placeholder="(555) 555-5555"
          type="tel"
          maxLength="14"
          label="Phone"
          required={false}
          autoComplete="off"/>
        {isManager && (<Forms.Select {...form} name="provider" options={getAssistingTeamMember(providers)} label="Assisting Team Member"/>)}
        <SendThankYou form={form} defaultThankYouDelay={defaultThankYouDelay}/>
        <Forms.Button {...form} label="Add Contact"/>
        <div className="form-footer">You are adding a contact to {businessName}</div>
      </ul>
    </div>
  );
}


function getAssistingTeamMember(providers) {
  const noTeamMember = [ '', 'No Team Member' ];
  // 2018-03-25 Bug in the API: it returns multiple providers with the same ID
  const unique = providers.reduce((all, provider) => ({ ...all, [provider.id]: provider.name }), {});
  const sorted = Object.entries(unique).sort(byProviderName);
  return sorted.concat([ noTeamMember ]);
}


function byProviderName(a, b) {
  return a[1].localeCompare(b[1]);
}

function getDelayLabel(value) {
  const label = (value === 0) ? 'now' : `in ${ms(value, { long: true })}`;
  return label;
}

// default defaultThankYouDelay in ms
function getDelayOptions(defaultThankYouDelay) {
  const options = [ 0, ms('15m'), ms('1h'), defaultThankYouDelay ];
  const unique  = [ ...new Set(options.sort((a, b) => a - b)) ];

  const selectOptions = unique.map(function(delay) {
    return [ delay, getDelayLabel(delay) ];
  });

  return selectOptions;
}

function SendThankYou({ form, defaultThankYouDelay }) {
  const value              = form.get('sendThankYou');
  const selectOptions      = getDelayOptions(defaultThankYouDelay);
  const shouldSendThankYou = value === 'yes';


  return (
    <div className="send-thank-you">
      <Forms.Radio
        {...form}
        label="Send a review request "
        name="sendThankYou"
        value="yes"
        defaultChecked={shouldSendThankYou}
        useRadioStyle={true}
        className={classnames('send-yes', { 'is-active': shouldSendThankYou })}
      >
        <React.Fragment>
          <section className="send-thank-you__delay">
            <Forms.Select
              {...form}
              name="sendDelay"
              readOnly={!shouldSendThankYou}
              options={selectOptions}
            />
          </section>
          <div className="item-subtitle">We will send a review request with the selected delay.</div>
        </React.Fragment>
      </Forms.Radio>

      <Forms.Radio
        {...form}
        label="Don't send a review request"
        name="sendThankYou"
        value="no"
        subtitle="You can send a review request later from the contact page."
        defaultChecked={!shouldSendThankYou}
        useRadioStyle={true}
        className={classnames('send-no', { 'is-active': !shouldSendThankYou  })}
      />
    </div>

  );
}
